import { FileText, ReceiptText } from 'lucide-react';

export interface BalanceCardProps {
  label: string;
  amount: string;
  leftLabel?: string;
  rightLabel?: string;
}

export function BalanceCard({
  label,
  amount,
  leftLabel = 'Add Expense',
  rightLabel = 'Add Payment',
}: BalanceCardProps) {
  return (
    <div className='mk-balance'>
      <p className='mk-balance__label'>{label}</p>
      <p className='mk-balance__amount'>{amount}</p>
      <div className='mk-balance__actions'>
        <span className='mk-balance__btn mk-balance__btn--ghost'>
          <FileText size={16} strokeWidth={2} />
          {leftLabel}
        </span>
        <span className='mk-balance__btn mk-balance__btn--primary'>
          <ReceiptText size={16} strokeWidth={2} />
          {rightLabel}
        </span>
      </div>
    </div>
  );
}
